import {useQuery} from '@tanstack/react-query'
import type {AxiosInstance} from 'axios'
import {useMemo} from 'react'

import {UpmPlantsContext} from '../contexts'
import type {UpmPlant, UpmPlantsContextValue} from '../types'

const fetchUpmPlants = async (api: AxiosInstance) => {
  const path = '/upm/plant'
  const response = await api.get<UpmPlant[]>(path)
  return response.data
}

// This is an ad-hoc solution to fix the current UPM state on the fly.
// Once all of the plants are correctly configured in UPM, this function can be removed.
const adjustUpmContext = (upmContext: UpmPlantsContextValue) => {
  // Rollback W025 --> IT29 renaming (remove once W025 is not used anymore)
  upmContext['W025'] = {...upmContext['IT29'], plantId: 'W025'}
  delete upmContext['IT29']

  return upmContext
}

interface UpmPlantsProviderProps {
  api: AxiosInstance
  children: React.ReactNode
}

export const UpmPlantsProvider: React.FC<UpmPlantsProviderProps> = ({api, children}) => {
  const {data: upmPlants} = useQuery({
    queryKey: ['upmPlants'],
    queryFn: () => fetchUpmPlants(api),
    staleTime: Infinity
  })

  const memoizedUmpPlantsData = useMemo(() => {
    if (!upmPlants) return

    return adjustUpmContext(
      upmPlants.reduce<UpmPlantsContextValue>((acc, plant) => {
        acc[plant.plantId] = plant
        return acc
      }, {})
    )
  }, [upmPlants])

  return (
    <UpmPlantsContext.Provider value={memoizedUmpPlantsData}>{children}</UpmPlantsContext.Provider>
  )
}
